/**
 * Aspect — Contact shadow cleanup
 * --------------------------------------------------------------
 * Footprint "blob" planes are intentionally disabled: they never match real
 * mesh silhouettes (legs, sofa bases, etc.). Grounding shadows come from the
 * sun + interior overhead spot shadow maps in environment.js.
 */

/** Always false — soft radial blobs removed. */
export function shouldHaveContactShadow() {
  return false;
}

/** Strip any leftover contact-shadow child from a furniture entity. */
export function removeContactShadow(entity) {
  if (!entity) return;
  const tagged = entity._aspectContactShadow;
  if (tagged) {
    tagged.destroy();
    entity._aspectContactShadow = null;
  }
  for (const child of [...(entity.children ?? [])]) {
    if (child.name === "contact-shadow" || child.name?.startsWith?.("contact-shadow") || child._aspectContactShadow) {
      child.destroy();
    }
  }
}

/** Only cleans leftovers; does not attach fake planes. */
export function syncContactShadow(entity) {
  removeContactShadow(entity);
}
